import React, { ReactNode } from 'react';
import { Typography, styled } from '@mui/material';

const Section = styled('section')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2.5, 3),
  background: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius,
  [theme.breakpoints.down('md')]: {
    padding: theme.spacing(2),
  },
}));

const Header = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
}));

const Number = styled('span')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 28,
  height: 28,
  padding: '0 6px',
  borderRadius: theme.shape.borderRadius,
  background: theme.palette.action.hover,
  color: theme.palette.text.secondary,
  fontSize: 12,
  fontWeight: 700,
}));

interface FormSectionProps {
  number: number;
  title: string;
  children: ReactNode;
}

const FormSection: React.FC<FormSectionProps> = ({ number, title, children }) => {
  return (
    <Section>
      <Header>
        <Number>{String(number).padStart(2, '0')}</Number>
        <Typography variant="subtitle1" fontWeight={700}>
          {title}
        </Typography>
      </Header>
      {children}
    </Section>
  );
};

export default FormSection;
